exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#mp-ui-modal {\n  position: fixed !important;\n}\n\n#mpui-environment-id {\n  position: fixed !important;\n}\n\n#mpui-environment-id-wrapper > div {\n  position: fixed !important;\n}\n", ""]);

